import React from "react";
import { PageContainer } from "@amzn/stencil-react-components/page";
import { Col, Hr, Row } from "@amzn/stencil-react-components/layout";
import { H1, H2, Text } from "../../../../components/typography";
import { defaultTextColor } from "../../../../config/palette";
import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { TAKE_BADGE_PHOTO_UPLOAD_URL } from "../../../../config/urls";
import { useNavigator } from "../../../../hooks/use-navigator";
import "./styles.scss";
import acceptableImgSrc from "../../images/acceptable-photo.png";
import unacceptableImgSrc from "../../images/unacceptable-photo.png";
export const BadgeUploadRequirementsRoute = () => {
  const [goToUpload] = useNavigator(TAKE_BADGE_PHOTO_UPLOAD_URL);

  return (
    <>
      <PageContainer color={defaultTextColor}>
        <Col gridGap="1rem">
          <H1 textAlign="center">Photo requirements</H1>
          <H2 className="do">Use photo</H2>
          <ul className="rules-list">
            <li>
              <Text>that have enough brightness and sharpness </Text>
            </li>
            <li>
              <Text>
                that includes your entire face, neck, and part of both shoulders
              </Text>
            </li>
            <li>
              <Text>that have solid white or off-white background</Text>
            </li>
          </ul>
          <H2 className="do">Acceptable Photos</H2>
          <Row flex="row">
            <Col gridGap="1rem">
              <img
                src={acceptableImgSrc}
                className="preview-image"
                alt="Acceptable Photos"
              />
            </Col>
          </Row>
          <H2 className="dont">Don&apos;t use photo</H2>
          <ul className="rules-list">
            <li>
              <Text>
                with sunglasses, hats, or anything else that obstructs your
                face.
              </Text>
            </li>
            <li>
              <Text>with digital filters</Text>
            </li>
            <li>
              <Text>that is blurred</Text>
            </li>
          </ul>
          <H2 className="dont">Unacceptable Photos</H2>
          <Row width="100%">
            <Col gridGap="1rem">
              <img
                src={unacceptableImgSrc}
                className="preview-image"
                alt="Unacceptable Photos"
              />
            </Col>
          </Row>
          <Hr />
          <Row justifyContent="center">
            <Button onClick={goToUpload} variant={ButtonVariant.Primary}>
              Start uploading
            </Button>
          </Row>
        </Col>
      </PageContainer>
    </>
  );
};
